export default "__VITE_ASSET__BIGjvLag__"